import sanitizeHtml from 'sanitize-html';

export const sanitize = (dirty: string) => sanitizeHtml(dirty);
